import { render, staticRenderFns } from "./YoutubePreview.vue?vue&type=template&id=3c2d0989"
import script from "./YoutubePreview.vue?vue&type=script&lang=js"
export * from "./YoutubePreview.vue?vue&type=script&lang=js"
import style0 from "./YoutubePreview.vue?vue&type=style&index=0&id=3c2d0989&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports